import { AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-signature-pad',
  standalone: true,
  imports: [],
  templateUrl: './signature-pad.component.html',
  styleUrl: './signature-pad.component.scss'
})
export class SignaturePadComponent implements AfterViewInit {

  @ViewChild('signatureCanvas') signatureCanvas!: ElementRef;

  @Output() signingFinished = new EventEmitter<string | null>();

  private ctx!: CanvasRenderingContext2D;
  isDrawing = false;

  ngAfterViewInit(): void {
    const canvas = this.signatureCanvas.nativeElement;
    this.ctx = canvas.getContext('2d');
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
  }

  startDrawing(event: MouseEvent | TouchEvent): void {
    this.isDrawing = true;
    this.ctx.beginPath();
    this.ctx.moveTo(this.getX(event), this.getY(event));
    event.preventDefault();
  }

  draw(event: MouseEvent | TouchEvent): void {
    if (!this.isDrawing) return;
    this.ctx.lineTo(this.getX(event), this.getY(event));
    this.ctx.stroke();
    event.preventDefault();
  }

  stopDrawing(): void {
    if (!this.isDrawing) {
      return;
    }

    this.isDrawing = false;
    this.signingFinished.emit(this.getSignatureAsBase64());
  }

  getSignatureAsBase64(): string {
    return this.signatureCanvas.nativeElement.toDataURL('image/png');
  }

  clearCanvas(): void {
    this.ctx.clearRect(0, 0, this.signatureCanvas.nativeElement.width, this.signatureCanvas.nativeElement.height);
    this.isDrawing = false;
    this.signingFinished.emit(null);
  }

  private getX(event: MouseEvent | TouchEvent): number {
    if (event instanceof MouseEvent) {
      return event.offsetX;
    } else {
      const target = event.target as Element;
      return event.touches[0].clientX - target.getBoundingClientRect().left;
    }
  }

  private getY(event: MouseEvent | TouchEvent): number {
    if (event instanceof MouseEvent) {
      return event.offsetY;
    } else {
      const target = event.target as Element;
      return event.touches[0].clientY - target.getBoundingClientRect().top;
    }
  }
}
